import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import * as userActions from "./../../../../actions/user.actions";
import * as commonActions from "./../../../../actions/common.actions";
import * as projectActions from "./../../../../actions/project.actions";
import VerifyAccount from "../components/VerifyAccount/VerifyAccount";

class VerifyAccountContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      revalidate: {
        number: false,
        name: false,
        ccv: false,
        expiration_date: false
      }
    };
  }

  componentDidMount() {
    this.props.projectActions.getProjects();
  }

  componentWillUnmount() {
    this.removeErrors();
  }

  removeErrors() {
    this.props.commonActions.showError(null);
  }

  revalidateField() {
    if (this.props.commonError != null) {
      this.setState({
        revalidate: {
          number: true,
          name: true,
          ccv: true,
          expiration_date: true
        }
      });
    }
  }

  handleSubmit(data) {
    const { projectCount, location } = this.props;

    if (!data.codeCheckBox) {
      delete data.referral_code;
    }

    if (location && location.state && location.state.projectId)
      data.project_id = location.state.projectId;

    this.props.actions.verifyAccount(data, projectCount);
    if (this.props.commonError) {
      this.setState({
        revalidate: {
          number: false,
          name: false,
          ccv: false,
          expiration_date: false
        }
      });
    }
  }

  render() {
    const { number, name, ccv, expiration_date } = this.state.revalidate;

    return (
      <VerifyAccount
        onSubmit={this.handleSubmit.bind(this)}
        removeErrors={this.removeErrors.bind(this)}
        revalidateField={this.revalidateField.bind(this)}
        forceError={this.props.commonError}
        revalidate={{ number, name, ccv, expiration_date }}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    projectCount: state.project.projects.length,
    commonError: state.common.error,
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(userActions, dispatch),
    projectActions: bindActionCreators(projectActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VerifyAccountContainer);



// WEBPACK FOOTER //
// ./src/routes/employer/signUp/containers/VerifyAccountContainer.js